import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { GET } from "../../utils/HttpClient";
import { URL_POST_BAKING } from "../../constance/urls";
import * as _ from "lodash";
import ErrorMessage from "../common/ErrorMessage";
import { Form, DatePicker, Row } from "antd";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import dayjs from "dayjs";

export default function EnterGroupDate(props) {
  const {
    onEnter,
  } = props;

  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null)
  const [form] = Form.useForm();
  const date = Form.useWatch('date', form);

  const handleSubmit = async ({ date }) => {
    setLoading(true);
    try {
      const validate = await form.validateFields();
      date = dayjs(validate.date).format(DATE_FORMAT)
      const response = await GET(URL_POST_BAKING.CHECK_POST_BAKING_GROUP, { date: date })
      if (_.get(response, 'data.exists', false)) {
        onEnter(date)
      } else {
        setErrorMessages(t('post_baking_waste_wood_count.errors.no_wood'))
      }
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    if (date) {
      handleSubmit(date)
    }
  }, [date])

  return (
    <div>
      <Form style={{ margin: '24px', }} form={form} initialValues={{ date: null }}>
        <ErrorMessage message={errorMessages} />
        <Row justify={'center'}>
          <Form.Item
            name={'date'}
            label={t('post_baking_waste_wood_count.group_date')}
            rules={[{ required: true, message: t('error_messages.validation.required') }]}>
            <DatePicker
              placeholder={t('searchs.placeholders.date')}
              format={HUMAN_DATE_FORMAT}
              style={{ width: '100%' }} />
          </Form.Item>
        </Row>
      </Form>
    </div >
  )
}

EnterGroupDate.propTypes = {
  onEnter: PropTypes.func,
}

EnterGroupDate.defaultProps = {
  onEnter: () => null,
}